import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=87875db2&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-styles/login-forms.css?vue&type=style&index=0&id=87875db2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87875db2",
  null
  
)

export default component.exports